<template>
  <v-card>
    <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>
    <v-card-title>
      <span class="display-1">LÄGG TILL PERSONAL</span>
    </v-card-title>

    <v-card-text class="mt-n4">
      <v-form ref="newEmployForm">
        <PersonFind ref="personfind" v-model="person" />

        <v-text-field
          data-cy="employee-role-description"
          outlined
          v-model="employee.roleDescription"
          label="Rollbeskrivning"
        ></v-text-field>
        <p class="caption mt-n6 mb-5">
          Denna text beskriver kortfattat vad personen arbetar med på företaget. Den
          påverkar inte personens behörigheter eller yrkesbevis utan är rent informativ
          för företagets medarbetare på Mina sidor. Exempel på rollbeskrivningar är
          “platschef” och “personalansvarig”.
        </p>

        <div class="roles__box roles__box--special">
          <div class="roles__box--border">
            <div class="roles__box--label">Roller</div>

            <p class="roles__box--info mt-2 ml-3">
              Den tilldelning av roller du gör här styr vilka behörigheter personen får på
              Mina sidor för detta företag.
            </p>

            <v-switch
              class="mt-0"
              data-cy="role-administrator"
              v-model="employee.isAdministrator"
              label="Företagsadministratör (FTGADM)"
            ></v-switch>
            <p class="roles__box--switches-text empl_p">
              Denna roll har fullständiga behörigheter att lägga till, 
              ändra och radera användare och uppgifter om företaget på Mina sidor. 
              Rollen kan inte godkänna delmoment i e-böcker.
            </p>

            <div v-if="selectedCompany && selectedCompany.hasDepartments">
              <v-switch
                v-model="employee.isDepartmentAdministrator"
                label="Avdelningsadministratör (AVDADM)"
              ></v-switch>
              <p class="roles__box--switches-text empl_p">
                Denna roll har fullständiga behörigheter lägga till, 
                ändra och radera användare och uppgifter i en eller flera av företagets 
                avdelningar på Mina sidor. 
                Rollen kan inte godkänna delmoment i e-böcker.
                <MultiSelect
                  class="roles__box--departments--multiselect"
                  v-if="
                    selectedCompany &&
                    selectedCompany.hasDepartments &&
                    employee.isDepartmentAdministrator
                  "
                  :list="departments"
                  label="AVDELNINGAR"
                  v-model="employee.administratorDepartmentIds"
                />
              </p>

              <v-switch
                v-model="employee.isDepartmentDistanceEducationAdministrator"
                label="Beställningsgodkännare (BG)"
              ></v-switch>
              <p class="roles__box--switches-text empl_p">
                Denna roll har behörighet att godkänna företagets beställningar av distansutbildningar 
                på Mina sidor och mandat att ingå avtal med betalningsansvar.
                <MultiSelect
                  class="roles__box--departments--multiselect"
                  v-if="
                    selectedCompany &&
                    selectedCompany.hasDepartments &&
                    employee.isDepartmentDistanceEducationAdministrator
                  "
                  :list="departments"
                  label="AVDELNINGAR"
                  v-model="employee.distanceEducationAdministratorDepartmentIds"
                />
              </p>

              <v-switch
                v-model="employee.isDepartmentEducationResponsible"
                label="Yrkesutbildningsansvarig (YUA)"
              ></v-switch>
              <p class="roles__box--switches-text empl_p">
                Denna roll har behörighet att utse handledare, koppla lärlingar till handledare och visa alla e-böcker på företaget. 
                Rollen kan inte godkänna delmoment i e-böcker. Rollen kan tilldela handledarroll till personal.
                <MultiSelect
                  v-if="
                    selectedCompany &&
                    selectedCompany.hasDepartments &&
                    employee.isDepartmentEducationResponsible
                  "
                  class="roles__box--departments--multiselect"
                  :list="departments"
                  label="AVDELNINGAR"
                  v-model="employee.educationResponsibleDepartmentIds"
                />
              </p>

              <v-switch
                v-model="employee.isDepartmentInstructor"
                label="Handledare (HL)"
              ></v-switch>
              <p class="roles__box--switches-text mb-4 empl_p">
                Denna roll kräver yrkesbevis eller handledardispens. En person med denna
                roll har behörighet att handleda en eller flera lärlingar (beroende på
                yrke) under lärling- eller kvalificeringstid på företaget, visa sina
                lärlingars e-böcker och godkänna delmoment i sina lärlingars e-böcker.
                <MultiSelect
                  class="roles__box--departments--multiselect"
                  v-if="
                    selectedCompany &&
                    selectedCompany.hasDepartments &&
                    employee.isDepartmentInstructor
                  "
                  :list="departments"
                  label="AVDELNINGAR"
                  v-model="employee.instructorDepartmentIds"
                />
              </p>
            </div>
            <div v-else>
              <v-switch
                v-model="employee.isDistanceEducationAdministrator"
                label="Beställningsgodkännare (BG)"
              ></v-switch>
              <p class="roles__box--switches-text empl_p">
                Denna roll har behörighet att godkänna företagets beställningar av
                distansutbildningar på Mina sidor och mandat att ingå avtal med
                betalningsansvar.
              </p>

              <v-switch
                v-model="employee.isCompanyEducationResponsible"
                label="Yrkesutbildningsansvarig (YUA)"
              ></v-switch>
              <p class="roles__box--switches-text empl_p">
                Denna roll har behörighet att utse handledare, koppla lärlingar till handledare och visa alla e-böcker på företaget. Rollen kan inte godkänna delmoment i e-böcker. 
                Rollen kan tilldela handledarroll till personal.
              </p>

              <v-switch
                v-model="employee.isInstructor"
                label="Handledare (HL)"
              ></v-switch>
              <p class="roles__box--switches-text mb-4 empl_p">
                Denna roll kräver yrkesbevis eller handledardispens. En person med denna
                roll har behörighet att handleda en eller flera lärlingar (beroende på
                yrke) under lärling- eller kvalificeringstid på företaget, visa sina
                lärlingars e-böcker och godkänna delmoment i sina lärlingars e-böcker.
              </p>
            </div>
          </div>
        </div>
      </v-form>
    </v-card-text>

    <v-card-actions class="justify-end mt-n1">
      <v-btn color="secondary" @click="$emit('close')">
        <v-icon>$sl-cancel</v-icon>Avbryt
      </v-btn>
      <v-btn data-cy="save-employee" @click="createEmploymentWorkplaces()">
        <v-icon>$sl-add</v-icon>Lägg till</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import API from "@/services/api.js";
import PersonFind from "@/components/common/PersonSelect/PersonFind";
import SelectWorkplaces from "@/components/common/SelectWorkplaces";
import MultiSelect from "@/components/common/SelectTypes/MultiSelect";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CompanyCreateEmployee",

  components: {
    PersonFind,
    SelectWorkplaces,
    MultiSelect,
  },
  data() {
    return {
      departments: [],
      employee: {
        personId: null,
        companyId: 0,
        workplaces: [],
        roleDescription: null,
        isAdministrator: false,
        isCompanyEducationResponsible: false,
        isDistanceEducationAdministrator: false,
        isInstructor: false,
        isDepartmentInstructor: false,
        isDepartmentEducationResponsible: false,
        isDepartmentDistanceEducationAdministrator: false,
        isDepartmentAdministrator: false,
        instructorDepartmentIds: [],
        educationResponsibleDepartmentIds: [],
        distanceEducationAdministratorDepartmentIds: [],
        administratorDepartmentIds: [],
      },
      //- Person model
      person: {},
    };
  },
  created() {
    this.getEmployments();
  },
  computed: {
    ...mapGetters("company", ["selectedCompany"]),
  },
  methods: {
    // @vuese
    //- Used to get all the  employements from the selected company
    getEmployments() {
      API.listDepartments(this.selectedCompany.id)
        .then((response) => {
          response.data.forEach((d) => {
            this.departments.push({
              id: d.id,
              name: d.name ? d.name : "",
            });
          });
        })
        .catch((error) => {
          console.log("get departments", error);
        });
    },
    createEmploymentWorkplaces() {
      if (!this.person || !this.person.id) {
        this.$events.fire("showError", "Person måste anges.");
      }

      this.employee.personId = this.person.id;
      this.employee.companyId = this.selectedCompany.id;

      API.setEmployment(this.employee)
        .then((response) => {
          this.$events.fire("showInfo", "Sparad.");
          this.$refs.newEmployForm.reset();
          this.$refs.personfind.$refs.findPersonForm.reset();
          this.$emit("close");
        })
        .catch((error) => {
          console.log("error.msg :>> ", error);
          if (error.response && error.response.data && error.response.data.msg) {
            this.$events.fire("showError", error.response.data.msg);
          }
        });
    },
  },
};
</script>

<style scoped>
.roles__box--special .v-input--selection-controls {
  margin-left: 11px;
}
.empl_p {
  padding-left: 58px !important;
}
</style>
